module.exports = __webpack_public_path__ + "img/9788936456412.dd8c3f49.jpg";